import { Outlet } from 'react-router-dom';
import { UserNav } from '../components/UserNav';
import { HelpButton } from '../components/HelpButton';
import AppSidebar from '../components/AppSidebar';
import {
  LayoutDashboard,
  Calendar,
  CheckSquare,
  ClipboardList,
  User,
} from 'lucide-react';

// Define navigation items specific to Vendor users grouped by section
const vendorNavigationGroups = [
  {
    title: 'Overview',
    items: [
      {
        name: 'Dashboard',
        href: '/vendor',
        icon: LayoutDashboard
      }
    ]
  },
  {
    title: 'Execution',
    items: [
      {
        name: 'Activities',
        href: '/vendor/activities',
        icon: Calendar
      },
      {
        name: 'My Activities',
        href: '/vendor/my-activities',
        icon: CheckSquare
      },
      {
        name: 'My Tasks',
        href: '/vendor/my-tasks',
        icon: ClipboardList
      }
    ]
  },
  {
    title: 'Account',
    items: [
      {
        name: 'Profile',
        href: '/vendor/profile',
        icon: User
      }
    ]
  }
];

export default function VendorLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppSidebar navigation={vendorNavigationGroups} />

      {/* Main content area */}
      <div className="flex flex-1 flex-col lg:pl-72">
        {/* Desktop header - hidden on mobile */}
        <div className="hidden lg:sticky lg:top-0 lg:z-40 lg:flex lg:h-14 lg:shrink-0 lg:items-center lg:justify-end lg:gap-x-4 lg:border-b lg:border-gray-200 lg:bg-white lg:px-6 lg:shadow-sm">
          <UserNav />
        </div>

        {/* Main content - Add mobile padding, reset on large screens */}
        <main className="flex-1 pt-16 lg:pt-0">
          <div className="py-2 px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Help Button - Available on all pages */}
      <HelpButton />
    </div>
  );
}